import { render, staticRenderFns } from "./Submit.vue?vue&type=template&id=0104b9da&scoped=true&"
import script from "./Submit.vue?vue&type=script&lang=js&"
export * from "./Submit.vue?vue&type=script&lang=js&"
import style1 from "../style.css?vue&type=style&index=1&id=0104b9da&prod&scoped=true&lang=css&"
import style2 from "./Submit.vue?vue&type=style&index=2&id=0104b9da&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0104b9da",
  null
  
)

export default component.exports